var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-bottom-sheet',{attrs:{"hide-overlay":true,"content-class":"mx-0 my-0"},model:{value:(_vm.isOffline),callback:function ($$v) {_vm.isOffline=$$v},expression:"isOffline"}},[_c('div',{staticClass:"error white--text px-1 py-1 text-center"},[_vm._v(" You are offline. Please check your network ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }